import React from "react";
// import { Table } from "evergreen-ui";
import Component from "@reactions/component";
import Cookies from "universal-cookie";
import Host from "../../assets/js/Host";
import Lottie from "lottie-react-web";
import { toast } from "react-toastify";
import * as GrIcons from "react-icons/gr";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import { withStyles, makeStyles } from "@mui/styles";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
// import { createMuiTheme } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";

import Paper from "@mui/material/Paper";
import * as AiIcons from "react-icons/ai";
import * as CgIcons from "react-icons/cg";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "react-bootstrap/Table";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Tooltip from "@mui/material/Tooltip";
import helpers from "../../assets/js/helper";
import feHost from "../../assets/js/feHost";
import axios from "../../assets/js/AxiosInterceptors";


const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
}))(Tooltip);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const cookies = new Cookies();
function ShowMissions(props) {
  const [state, setState] = React.useState({
    value: {
      verified: "",
      data: [],
      Usersdata: [],
      Users: [],
      check: "login",
      name: "",
      spin: false,
    },
  });
  const [selectedImage, setSelectedImage] = React.useState(null);
  const [showImages, setShowImage] = React.useState(false);

  const exportToCSV = (csvData, fileName) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    if (csvData && csvData.length > 0) {
      const ws = XLSX.utils.json_to_sheet(csvData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(
        data,
        fileName + "_" + Math.floor(Date.now() / 1000) + fileExtension
      );
    }
  };
  const handleExportFunction = () => {
    let arr = [];
    props?.units &&
      props?.units?.length &&
      props?.units?.map((itm, index) => {
        arr.push({
          "#": index + 1,
          "Request type": props?.request_type_name,
          "Request Date": props?.created_at
            ? helpers.formatDate(props?.created_at)
            : "0000-00-00",
          "Task Name": itm?.name,
          "Task Reason": itm?.reason,
          "Account Name": props?.account_name,
          "User Name": props?.user_name,
        });
      });
    exportToCSV(arr, "TasksUnits");
  };

  return (
    <Dialog
      fullScreen
      open={props.isShown}
      onClose={props.closeShowAllUnits}
      TransitionComponent={Transition}
    >
      <AppBar
        sx={{
          backgroundColor: "#1e6a99",
        }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={props.closeShowAllUnits}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6">
            {"All Missions for Task " + props?.id}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          width: "98%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          alignSelf: "center",
          flexDirection: "column",
          marginTop: "90px",
          '& .table':{
            captionSide: 'bottom !important',
             borderCollapse: 'collapse !important'
          },
          '& .td':{
            borderRight: '0 !important',
            borderLeft: '0 !important',
          }
        }}
      >
        {/* <div
          style={{
            width: "100%",
            height: "50px",
            backgroundColor: props?.dashboardMode ? "#132A3B" : "#2e6b95",
            margin: "10px 0",
            // borderRadius:'5px'
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              margin: "0 10px 0 10px",
            }}
          >
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "50%",
                width: "35px",
                height: "35px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0 0 10px -3px #fff",
                cursor: "pointer",
              }}
              onClick={handleExportFunction}
            >
              <HtmlTooltip
                title={
                  <React.Fragment>
                    <Typography color="inherit" style={{ fontFamily: "Cairo" }}>
                      تصدير
                    </Typography>
                  </React.Fragment>
                }
              >
                <div
                  style={{
                    display: "felx",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CgIcons.CgExport
                    style={{
                      fontSize: "25px",
                      color: "#000",
                      position: "relative",
                      top: "-1px",
                      left: "-1px",
                    }}
                  />
                </div>
              </HtmlTooltip>
            </div>
          </div>
          <div>
            <div
              style={{
                width: "fit-content",
                height: "30px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#fff",
                color: "#000",
                padding: "0  15px",
                margin: "0 10px",
                borderRadius: "5px",
              }}
            >
              <span style={{ margin: "0 2px" }}>{props?.units?.length}</span>
              <span style={{ fontWeight: "bold" }}>: عدد الوحدات</span>
            </div>
          </div>
        </div> */}
        <Table bordered hover className="roundedUnitsTable">
          <thead>
            <tr
              style={{
                backgroundColor: props?.dashboardMode ? "#132A3B" : "#2e6b95",
                color: "#fff",
              }}
            >
              <td style={{ fontSize: "13.5px" }}>#</td>
              <td style={{ fontSize: "13.5px" }}>Mission.ID</td>
              <td style={{ fontSize: "13.5px" }}>Status Status</td>
              <td style={{ fontSize: "13.5px" }}>Status Color</td>
              <td style={{ fontSize: "13.5px" }}>Status updated at</td>
              <td style={{ fontSize: "13.5px" }}>ToTal SubMissions</td>
              {props?.missions && props?.missions?.length > 0
                ? props?.missions[0]?.statusList?.map((itm, index) => {
                    return <td style={{ fontSize: "13.5px" }}>{itm?.name}</td>;
                  })
                : null}
            </tr>
          </thead>
          <tbody>
            {props?.missions && props?.missions?.length > 0 ? (
              props?.missions?.map((itm, index) => {
                return (
                  <tr>
                    <td>{index + 1}</td>
                    <td>
                      <a
                        href={`${feHost}mission_details?id=${itm?.mission_id}`}
                        style={{ textDecoration: "underline" }}
                        target="_blank"
                      >
                        {itm?.mission_id}
                      </a>
                    </td>
                    <td>{itm?.status_name}</td>
                    <td>{itm?.status_color}</td>
                    <td>{itm?.status_updated_at}</td>
                    <td>{itm?.sub_missions_count}</td>
                    {itm && itm?.statusList?.length > 0
                      ? itm?.statusList?.map((itm, index) => {
                          return (
                            <td>{itm?.total_submission_per_status}</td>
                          );
                        })
                      : null}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={4} style={{ textAlign: "center" }}>
                  Theres No Data
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Box>
    </Dialog>
  );
}
export default ShowMissions;
